import { Modal } from "components/ui/modals/Modal/Modal"
import { FeedbackPanel } from "components/ui/FeedbackPanel/FeedbackPanel"
import { QuotationSettingsModal } from "components/pages/PageAllFiles/layout/FileInfo/layout/Quotations/layout/QuotationSettingsModal/QuotationSettingsModal"
import { useViewerStore } from "store/viewer.store"
import type { TDrawingStatus } from "types/drawer.type"

type Props = {
	drawingId: number
	processingId: number | null
	quotationId?: number
	processingUrl: string
	drawingStatus: TDrawingStatus
}

// The editor header's "Quotation configuration" and "Share feedback" dialogs. They are opened
// through `viewer.store` flags, so whichever host renders the editor must render these too — the
// Quotations drawer and the pop-out window (#1430) both do, through this one component.
export const QuotationEditorDialogs = ({ drawingId, processingId, quotationId, processingUrl, drawingStatus }: Props) => {
	const { isQuotationFeedbackOpen, closeQuotationFeedback, isQuotationSettingsOpen, closeQuotationSettings } =
		useViewerStore()

	return (
		<>
			<QuotationSettingsModal
				isModalOpen={isQuotationSettingsOpen}
				setModalClose={closeQuotationSettings}
				quotationId={quotationId}
			/>
			{/*
			 * FeedbackPanel is rendered un-gated (not behind `isQuotationFeedbackOpen &&`) so that
			 * Ant Design keeps it mounted after the first open. That preserves the typed feedback and
			 * attached screenshots while the modal is closed, until the user actually sends them.
			 */}
			<Modal
				isModalOpen={isQuotationFeedbackOpen}
				setModalClose={closeQuotationFeedback}
				closable={false}
				width={560}
				styles={{ content: { padding: 0 }, body: { padding: 0, maxHeight: "85vh", overflow: "auto" } }}
			>
				<FeedbackPanel
					variant="white"
					onClose={closeQuotationFeedback}
					drawingId={drawingId}
					processingId={processingId}
					processingUrl={processingUrl}
					drawingStatus={drawingStatus}
				/>
			</Modal>
		</>
	)
}
